import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import { RawUser } from '@entities/User/Types';
import ApiRequest from '../../Decorators/ApiRequest';
import { API_DEFAULT_HEADERS } from '@configs/ApiDefaultHeaders';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';

const BASE_URL = import.meta.env.VITE_BASE_URL_CUSTOMER;

export class MyProfileInfoGateway {
    async getMyProfileInfo(): Promise<ApiResult<RawUser>> {
        try {
            const response = await ApiRequest(`${BASE_URL}/my_profile_info`, {
                method: 'GET',
                headers: API_DEFAULT_HEADERS,
            });

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to add get profile info',
                };
            }
            const json: RawUser = await response.json();
            return {
                error: false,
                data: json as RawUser,
            };
        } catch (error) {
            return {
                error: true,
            };
        }
    }
}
